import { DefaultLayout } from '@/layouts';
import { ErrorScreen } from '@/components/shared/ErrorScreen';

export const ErrorPage = () => {
  return (
    <DefaultLayout>
      <ErrorScreen />
    </DefaultLayout>
  );
};
